import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUpdateAlternativeLabelsCommand && _ctx.handleUpdateAlternativeLabelsCommand(...args)), ["prevent"]))
    }, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"container\" style=\"margin-top:80px;padding-top:40px;\"><div class=\"row\"><div class=\"col-lg-6\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin:0;\">Edit labels</h1></div><div class=\"col-lg-6 text-right\"><button type=\"submit\" class=\"btn btn-success\" style=\"padding:0.7em 2em;\">Save changes</button></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 60px;\">", 2)),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "shadow-none p-3 mb-3 bg-light rounded" }, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "You can replace the word “alternative” with a more relevant word like “car” or “vendor”.")
              ]),
              _createElementVNode("p", null, " “Alternatives” is the word decision scientists use to describe the things you are choosing between. Chances are, you’re not a decision scientist and you’re trying to choose between real-world “things” like cars, the potential sites of a new warehouse or a vendor. ")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Single alternative:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rm.AlternativeLabel) = $event)),
                class: "form-control",
                required: "",
                minlength: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.rm.AlternativeLabel,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-muted" }, "What word would you like to use when talking about just one “alternative”?", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("label", null, "Multiple alternatives:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rm.AlternativesLabel) = $event)),
                class: "form-control",
                required: "",
                minlength: "2"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.rm.AlternativesLabel,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted" }, "What word would you like us to use for more than one “alternative”?", -1 /* CACHED */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 32 /* NEED_HYDRATION */)
  ]))
}